export default __webpack_public_path__ + "static/media/B119.5adf9b09.png";